<template>
  <b-container fluid class="m-0 p-0">
    <b-row>
      <b-col cols="12" class="m-0">
        <div class="border-label">
          <p class="m-0">{{ label }}</p>
        </div>
      </b-col>
      <b-col cols="12" class="m-0">
        <div class="border-field">
          <p class="m-0">{{ field }}</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "FieldAndLabel",

  props: ["label", "field"],

  data() {
    return {};
  },
  
};
</script>

<style lang="scss" scoped>
.border-label {
  margin: 0;
  text-align: left;
  padding-left: 1px;
}
.border-field {
  border: 1px solid #adb5bd;
  border-radius: 2px;
  height: 30px;
  padding-left: 8px;
  padding-top: 3px;
  text-align: left;
  font-size: 0.9rem;
}
</style>
